// 主题注册表 —— 单一数据源，被 ThemeProvider 与 ThemeCenter 共用
export type ThemeId =
  | 'celestial'
  | 'nebula'
  | 'cyber'
  | 'luxury'
  | 'terminal'
  | 'editorial';

export interface ThemeMeta {
  id: ThemeId;
  /** 中文名 */
  name: string;
  /** 英文名 */
  en: string;
  /** 一句话描述 */
  desc: string;
  /** 方案标记 A/B/C（新增方向） */
  tag?: 'A' | 'B' | 'C';
  /** 是否为浅色主题（联动 data-mode=light） */
  light?: boolean;
  /** 预览色板 */
  swatch: string[];
}

export const THEMES: ThemeMeta[] = [
  {
    id: 'celestial',
    name: '星辉',
    en: 'Celestial',
    desc: '经典橙红星空调',
    swatch: ['#ffcc00', '#ff4d4d', '#00ffff', '#ff2d55'],
  },
  {
    id: 'nebula',
    name: '星云',
    en: 'Nebula',
    desc: '靛紫梦境渐变',
    swatch: ['#a78bfa', '#6366f1', '#c084fc', '#818cf8'],
  },
  {
    id: 'cyber',
    name: '赛博',
    en: 'Cyber',
    desc: '翠绿终端质感',
    swatch: ['#34d399', '#22d3ee', '#10b981', '#2dd4bf'],
  },
  {
    id: 'luxury',
    name: '鎏金',
    en: 'Luxury',
    desc: '克制金 · 暗夜奢华（方案A）',
    tag: 'A',
    swatch: ['#e6b450', '#f59e0b', '#7dd3fc', '#b8860b'],
  },
  {
    id: 'terminal',
    name: '极客',
    en: 'Terminal',
    desc: '近黑等宽硬边（方案B）',
    tag: 'B',
    swatch: ['#22c55e', '#4ade80', '#86efac', '#16a34a'],
  },
  {
    id: 'editorial',
    name: '刊格',
    en: 'Editorial',
    desc: '浅色蓝调编辑杂志风（方案C）',
    tag: 'C',
    light: true,
    swatch: ['#0ea5e9', '#1e293b', '#f8fafc', '#6366f1'],
  },
];

export const DEFAULT_THEME: ThemeId = 'celestial';
export const THEME_STORAGE_KEY = 'xf_theme';

export function isThemeId(value: string | null): value is ThemeId {
  return !!value && THEMES.some((t) => t.id === value);
}
